import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"

import SEO from "../components/seo"


import MeinImage from "../components/MeinImage"


const Fotos = (props) => {

  return (
    <Layout location={props.location} title={props.data.site.siteMetadata.title}>
      
        <SEO
          title="Zimmervermietung in Bacharach"
          keywords={[`Zimmervermietung`,`Vermietung`,`Bacharach`, `Welterbe Mittelrheintal`, `Frackgalerie`, `Urlaub`]}
        />
        
       
        <MeinImage bildtitel="Blick auf Kaub" daten={props.data.b1.childImageSharp.fluid} alter="Der Rhein und Umgebung"/>
        <MeinImage bildtitel="Blick auf Bachrach" daten={props.data.b2.childImageSharp.fluid} alter="Der Rhein und Umgebung"/>
        <MeinImage bildtitel="Blick auf Bacharach" daten={props.data.b3.childImageSharp.fluid} alter="Der Rhein und Umgebung"/>
        <MeinImage bildtitel="Blick auf den Rhein" daten={props.data.b4.childImageSharp.fluid} alter="Der Rhein und Umgebung"/>
        <MeinImage bildtitel="Auf den Berghöhen von Bacharach" daten={props.data.b5.childImageSharp.fluid} alter="Der Rhein und Umgebung"/>
        
        
      </Layout>
)}
  

export default Fotos


export const fotosQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    b1: file(absolutePath: { regex: "/15.jpg/" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    b2: file(absolutePath: { regex: "/1.jpg/" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    } 
    b3: file(absolutePath: { regex: "/16.jpg/" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    } 
    b4: file(absolutePath: { regex: "/9.jpg/" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      } 
    b5: file(absolutePath: { regex: "/5.jpg/" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      } 
      
         

  }
`
